import React, { PropsWithChildren } from "react";
import { Menu, Avatar, HStack, Text, Separator, Box } from "@chakra-ui/react";
import { useNavigate, Link } from "react-router-dom";
import { logo } from "assets/images";

type ProfileMenuProps = {
  value?: string;
};

const ProfileMenu: React.FC<PropsWithChildren<ProfileMenuProps>> = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/logout");
  };

  // const handleProfile = () => {
  //   navigate("/profile");
  // };

  const handleWallet = () => {};
  return (
    <Menu.Root
      closeOnSelect
      loopFocus
      typeahead
      lazyMount
      skipAnimationOnMount
      positioning={{
        placement: "bottom-end",
        offset: { mainAxis: 5, crossAxis: 0 },
      }}
      variant="subtle"
      size="md"
    >
      <Menu.Trigger
        rounded="full"
        // focusRing="outside"
        aria-label="Open profile menu"
      >
        <HStack
          gap={2}
          cursor="pointer"
          px={2}
          py={1}
          rounded="full"
          _hover={{ bg: "gray.100" }}
          _active={{ bg: "gray.200" }}
          transition="background 120ms ease"
        >
          <Avatar.Root size="sm">
            <Avatar.Fallback name="Profile" />
            <Avatar.Image src={logo} alt="profile" />
          </Avatar.Root>

          <Text
            fontSize="sm"
            fontWeight="semibold"
            color="gray.800"
            display={{ base: "none", md: "block" }}
          >
            Profile
          </Text>

          {/* <Box
            as={BsChevronDown}
            boxSize={3.5}
            color="gray.500"
            display={{ base: "none", md: "block" }}
          /> */}
        </HStack>
      </Menu.Trigger>

      <Menu.Positioner>
        <Menu.Content
          minW="240px"
          p={2}
          rounded="lg"
          shadow="xl"
          borderWidth="1px"
          borderColor="blackAlpha.100"
          bg="whiteAlpha.900"
          backdropFilter="saturate(180%) blur(8px)"
          _dark={{
            bg: "blackAlpha.800",
            borderColor: "whiteAlpha.200",
          }}
          data-testid="profile-menu"
        >
          {/* Top user strip */}
          <HStack gap={3} px={3} py={2}>
            <Avatar.Root size="sm">
              <Avatar.Fallback name="Profile" />
              <Avatar.Image src={logo} alt="profile" />
            </Avatar.Root>
            <Box>
              <Text fontWeight="semibold" lineHeight="short">
                Profile
              </Text>
              <Text fontSize="xs" color="gray.500">
                Manage your account
              </Text>
            </Box>
          </HStack>

          <Separator my={1} />

          {/* Menu Items */}
          <Menu.Item
            value="view-profile"
            asChild
            aria-label="View Profile"
            rounded="md"
            px={3}
            py={2}
            _hover={{ bg: "gray.50" }}
            _active={{ bg: "gray.100" }}
            _dark={{
              _hover: { bg: "whiteAlpha.100" },
              _active: { bg: "whiteAlpha.200" },
            }}
          >
            <Link to="/profile" style={{ width: "100%" }}>
              View Profile
            </Link>
          </Menu.Item>

          <Menu.Item
            value="wallet"
            onSelect={handleWallet}
            asChild
            aria-label="Wallet"
            rounded="md"
            px={3}
            py={2}
            _hover={{ bg: "gray.50" }}
            _active={{ bg: "gray.100" }}
            _dark={{
              _hover: { bg: "whiteAlpha.100" },
              _active: { bg: "whiteAlpha.200" },
            }}
          >
            <Link to="/wallet" style={{ width: "100%" }}>
              Transactions History
            </Link>
          </Menu.Item>
          <Menu.Item
            value="bbps-complaints"
            asChild
            aria-label="BBPS Transactions & Complaints"
            rounded="md"
            px={3}
            py={2}
            _hover={{ bg: "gray.50" }}
            _active={{ bg: "gray.100" }}
            _dark={{
              _hover: { bg: "whiteAlpha.100" },
              _active: { bg: "whiteAlpha.200" },
            }}
          >
            <Link to="/bbps" style={{ width: "100%" }}>
              BBPS Complaints
            </Link>
          </Menu.Item>

          <Separator my={1} />

          <Menu.Item
            value="logout"
            onSelect={handleLogout}
            aria-label="Logout"
            rounded="md"
            px={3}
            py={2}
            color="red.600"
            _hover={{ bg: "red.50" }}
            _active={{ bg: "red.100" }}
            _dark={{
              color: "red.300",
              _hover: { bg: "red.900", color: "red.100" },
              _active: { bg: "red.800" },
            }}
          >
            Logout
          </Menu.Item>

          <Menu.Arrow />
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
};

export default ProfileMenu;

// import React, { PropsWithChildren } from "react";
// import {
//   Menu,
//   Avatar,
//   HStack,
//   Text,
//   Separator,
// } from "@chakra-ui/react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { logout } from "store/features/user/userActions";
// import { logo } from "assets/images";
// import { Link } from "react-router-dom";

// type ProfileMenuProps = {
//   value?: string;
// };

// const ProfileMenu: React.FC<PropsWithChildren<ProfileMenuProps>> = ({
//   value,
//   children
// }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     dispatch(logout());
//     navigate("/", { replace: true });
//   };

//   return (
//     <Menu.Root
//       positioning={{ placement: "bottom-end", offset: { mainAxis: 8 } }}
//       closeOnSelect
//       typeahead
//       //   colorPalette="gray"
//       variant="subtle"
//       size="md"
//     >
//       <Menu.Trigger
//         rounded="full"
//         focusRing="outside"
//         aria-label="Open profile menu"
//       >
//         <HStack gap={2} cursor="pointer">
//           <Avatar.Root size="sm">
//             {/* <Avatar.Fallback name={name} /> */}
//             <Avatar.Image src={logo} alt={"profile"} />
//           </Avatar.Root>
//           <Text
//             fontSize="sm"
//             fontWeight="medium"
//             display={{ base: "none", md: "block" }}
//           >
//             {"profile"}
//           </Text>
//         </HStack>
//       </Menu.Trigger>

//       {/* <Portal> */}
//       <Menu.Positioner>
//         <Menu.Content
//           minW="220px"
//           p={2}
//           rounded="md"
//           shadow="lg"
//           data-testid="profile-menu"
//         >
//           {/* Header (static) */}
//           <HStack gap={3} px={2} py={2}>
//             <Avatar.Root size="sm">
//               <Avatar.Fallback name={"profile"} />
//               <Avatar.Image src={logo} alt={"profile"} />
//             </Avatar.Root>
//             <Text fontWeight="semibold" lineHeight="short">
//               {"profile"}
//             </Text>
//           </HStack>

//           <Separator my={1} />

//           {/* Items */}
//           <Menu.Item value="view-profile" asChild aria-label="View Profile">
//             <Link to="/account/profile">View Profile</Link>
//           </Menu.Item>

//           <Menu.Item value="wallet" asChild aria-label="Wallet">
//             <Link to="/account/wallet">Wallet</Link>
//           </Menu.Item>

//           <Separator my={1} />

//           <Menu.Item value="logout" onSelect={handleLogout} aria-label="Logout">
//             Logout
//           </Menu.Item>
//         </Menu.Content>
//       </Menu.Positioner>
//       {/* </Portal> */}
//     </Menu.Root>
//   );
// };

// export default ProfileMenu;
